import React from "react";

const Footer = () => {
  return (
    <div className="py-5 text-center bg-[#0a192f] text-yellow-500">
      <footer id="footer">
        <div className="container">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>Haryana Library Association</span>
            </strong>
            . All Rights Reserved
          </div>
          <div className="text-fuchsia-600 text-sm font-bold">
           <span className="text-gray-200" > Designed and Hosted by </span> <a href="https://hla.essnet.in/"> Dr. Lakhpat Singh (Librarian)</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
